'use client';

import { motion } from 'motion/react';
import { NumberTicker } from '@/components/sections/stats/number-ticker';
import { useSectionMotionVariants } from '@/components/shared/motion';
import { useIsMobile } from '@/hooks/use-mobile';
import type { StatsSectionContent } from '@/sanity/lib/sections';

type StatContentItem = NonNullable<StatsSectionContent['stats']>[number] & {
  value: number;
  suffix: string;
  label: string;
};

export default function Stat({ s, index }: { s: StatContentItem; index: number }) {
  const isMobile = useIsMobile();
  const { sectionCardRevealVariants } = useSectionMotionVariants();

  return (
    <motion.div
      variants={sectionCardRevealVariants}
      className="flex flex-col items-start sm:items-center text-left sm:text-center"
    >
      <div className="text-6xl tracking-tight font-medium text-white sm:text-7xl flex items-center">
        <NumberTicker
          value={s.value}
          delay={isMobile ? 0.1 + index * 0.04 : 0.28 + index * 0.09}
          stiffness={isMobile ? 45 : undefined}
        />
        <span className="text-[#FCFAD7] font-light pl-3 text-4xl xl:text-5xl">{s.suffix}</span>
      </div>
      <div className="mt-3 text-xs md:text-sm leading-relaxed font-medium uppercase text-balance tracking-wider text-muted-foreground">
        {s.label}
      </div>
    </motion.div>
  );
}
